import { Dispatch, SetStateAction, useEffect, useRef } from "react";

export const useIntersectionObserver = (
  setActiveId: Dispatch<SetStateAction<string>>
) => {
  const headingElementsRef = useRef<any>({});
  useEffect(() => {
    const callback = (headings: IntersectionObserverEntry[]) => {
      headingElementsRef.current = headings.reduce((map, headingElement) => {
        map[headingElement.target.id] = headingElement;
        return map;
      }, headingElementsRef.current);

      const visibleHeadings: IntersectionObserverEntry[] = [];
      Object.keys(headingElementsRef.current).forEach((key) => {
        const headingElement = headingElementsRef.current[key];
        if (headingElement.isIntersecting) visibleHeadings.push(headingElement);
      });

      const getIndexFromId = (id: string) =>
        headingElements.findIndex((heading) => heading.id === id);

      const compare = (
        a: IntersectionObserverEntry,
        b: IntersectionObserverEntry
      ) => {
        const result =
          getIndexFromId(a.target.id) - getIndexFromId(b.target.id);
        if (result > 0) return 1;
        if (result < 0) return -1;
        return 0;
      };

      if (visibleHeadings.length === 1) {
        setActiveId(visibleHeadings[0].target.id);
      } else if (visibleHeadings.length > 1) {
        const sortedVisibleHeadings = visibleHeadings.sort(compare);
        setActiveId(sortedVisibleHeadings[0].target.id);
      }
    };

    const observer = new IntersectionObserver(callback);

    const headingElements = Array.from(document.querySelectorAll("h2, h3"));
    headingElements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [setActiveId]);
};
